import { useEffect, useState } from "react";
import About from "./Components/About";
import Experience from "./Components/Experience";
import Footer from "./Components/Footer";
import Header from "./Components/Header";
import Modal from "./Components/Modal";
import Nav from "./Components/Nav";
import Projects from "./Components/Projects";
import Social from "./Components/Social";
import "./Components/style.css";

function App() {
  // Animation on scrolling
  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        // console.log(entry);

        if (entry.isIntersecting) {
          entry.target.classList.add("show");
        } else {
          entry.target.classList.remove("show");
        }
        // observer.unobserve(entry.target)
      });
    });
    const hiddenElements = document.querySelectorAll(".hidden");
    hiddenElements.forEach((el) => observer.observe(el));
  }, []);

  const [showModal, setShowModal] = useState(false);

  const showModalNow = () => {
    return setShowModal(true);
  };

  const hideModalNow = () => {
    return setShowModal(false);
  };

  return (
    <>
      <Header showModalNow={showModalNow} />
      <Social/>
      <Nav showModalNow={showModalNow} />
      <About className="hidden" />
      {showModal && <Modal hideModalNow={hideModalNow} />}
      <Experience className="hidden" />
      <Projects className="hidden" />
      <Footer className="hidden"/>
    </>
  );
}

export default App;
